/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import SearchingQueryResponseMapModelstringListPermissionDetailsDto from '../model/SearchingQueryResponseMapModelstringListPermissionDetailsDto';

/**
* Permission service.
* @module api/PermissionApi
* @version v1.0.0
*/
export default class PermissionApi {

    /**
    * Constructs a new PermissionApi. 
    * @alias module:api/PermissionApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getPermissionsUsingGET operation.
     * @callback module:api/PermissionApi~getPermissionsUsingGETCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SearchingQueryResponseMapModelstringListPermissionDetailsDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get and Search Permissions
     * @param {Object} opts Optional parameters
     * @param {String} opts.keyword search keyword
     * @param {module:api/PermissionApi~getPermissionsUsingGETCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SearchingQueryResponseMapModelstringListPermissionDetailsDto}
     */
    getPermissionsUsingGET(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'keyword': opts['keyword']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Authorization'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = SearchingQueryResponseMapModelstringListPermissionDetailsDto;
      return this.apiClient.callApi(
        '/api/permission', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
